import axios from 'axios';
const state = {};
import config from '@/../config';
const defaultErrorHandler = error => Promise.reject(error.response);

const mutations = {};

const actions = {
  async GET_TAKER_LIDER({ commit }, payload) {

    let response;
    response = await axios.get(
      config.apiUrl + config.versoes[0] + '/corretorTomador/' + payload.documento,
    );
    return response.data;
  },

  async GET_TAKER_DATA({ commit }, payload) {

    let response;
    response = await axios.get(
      config.apiUrl + config.versoes[0] + '/tomador/?documento=' + payload.cnpj,
      { timeout: 600000 }
    );
    return response.data;
  },

  async GET_INSURED_TAKER({ commit }, payload) {
    
    let response;
    response = { insured: 'Corretor teste', broker: 'Corretora Umuarama', modalidades: ['Modalidade 1', 'Modalidade 2'] };
    return response;
  },

  async GET_TAKER_LIMITES({ commit }, payload) {
    
    let response;
    response = await axios.get(config.apiUrl + config.versoes[0] + '/tomador/' + payload.id + '/limites', { timeout: 600000 })

    return response.data;
  },

  async GET_TAKER_APOLICES({ commit }, payload) {
    let propostas;
    let page;
    await axios({
      method: 'post',
      url: config.apiUrl + config.versoes[0] + `/propostaTomador/${payload.cnpj}`,
      data: {
        "pagina": payload.pagina_atual ? payload.pagina_atual : 0,
        "itens_por_pagina": payload.total_pagina ? payload.total_pagina : 0,
        "segurado": payload.segurado ? payload.segurado : null,
        "vigencia_inicio": payload.vigencia_inicio ? payload.vigencia_inicio : null,
        "vigencia_fim": payload.vigencia_fim ? payload.vigencia_fim : null,
        "emissao_inicio": payload.emissao_inicio ? payload.emissao_inicio : null,
        "emissao_fim": payload.emissao_fim ? payload.emissao_fim : null,
        "modalidade": payload.modalidade ? payload.modalidade : null,
        "grupo_modalidade": payload.grupo_modalidade ? payload.grupo_modalidade : null,
        "vigente": payload.vigente == null ? true : payload.vigente
      }
    }).then(res => {
      var { pagina, itens_por_pagina, total_pagina } = res.data;
      page = { pg: pagina, itens_pg: itens_por_pagina, total_pg: total_pagina };
      propostas = res.data.propostas
    });
    return { page, apolices: propostas };
  },

  async GET_PARAMETERS_TOMADOR({
    commit
  }, payload) {

    let response = await axios.get(config.apiUrl + config.versoes[0] + `/parametros/tomador`)

    return response.data;
  },

  async GET_FILTERS_APOLICES({ commit }, payload) {
    let response = await axios.get(
      config.apiUrl + config.versoes[0] + `/propostaTomador/${payload.cnpj}/filtros`
    );

    return response.data;
  }
};

export default {
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/taker.js